export const formatDuration = (
  start?: string | null,
  end?: string | null,
  runningLabel?: string
): string => {
  if (!start) {
    return "-";
  }

  const startMs = new Date(start).getTime();
  if (Number.isNaN(startMs)) {
    return "-";
  }

  const endMs = end ? new Date(end).getTime() : Date.now();
  if (Number.isNaN(endMs)) {
    return "-";
  }

  const totalSeconds = Math.max(0, Math.floor((endMs - startMs) / 1000));
  if (!end && runningLabel) {
    return `${formatDurationSeconds(totalSeconds)} (${runningLabel})`;
  }

  return formatDurationSeconds(totalSeconds);
};

export const formatDurationSeconds = (totalSeconds: number): string => {
  if (totalSeconds < 60) {
    return `${totalSeconds}s`;
  }

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes < 60) {
    return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (remainingMinutes > 0) {
    return `${hours}h ${remainingMinutes}m`;
  }
  return `${hours}h`;
};
